import React, { useState } from "react";
import './style.scss'
const MemberButton = ({
    type = 'filled',
    onClick, 
    children,
    className = '',
    disabled = false,
    icon,
}) => {
    const [isActive, setIsActive] = useState(false)
    const getButtonStyle = () => {
        switch (type) {
            case 'filled':
                return 'filled-button'   
            case 'outlined':
                return 'outlined-button'   
            default:
                return 'outlined-button'   
        }
    }
    return (
        <button
            onClick={onClick}
            onTouchStart={() => setIsActive(true)}
            onTouchEnd={() => setIsActive(false)}
            disabled={disabled}
            className={`${getButtonStyle()} ${isActive && !disabled ? getButtonStyle()+'-active' : ''}  ${disabled ? getButtonStyle()+'-disabled' : ''} ${className}`}
        >
            {type === 'icon' && icon && <span className="button-icon">{icon}</span>}
            {children}
        </button>
    )
}

export const MemberAppButtonBox = ({children,className=''}) => {
    return (
        <div className={`app-button ${className}`}>
           {children}
        </div>       
    )
}

export default MemberButton